import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    medicacionActual: [],
  },

  getters: {
    getMedicacionActual: (state) => state.medicacionActual,
  },

  mutations: {
    SET_MEDICACION_ACTUAL(state, medicacionActual) {
      state.medicacionActual = medicacionActual;
    },
  },

  actions: {
    async fetchMedicacionActual({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/medicacionActual`)
        .then((response) => {
          commit('SET_MEDICACION_ACTUAL', response.data.data);
        });
    },

    async saveMedicacionActual(context, medicacionActual) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;

      await Promise.all(
        medicacionActual.map(async (medicamento) => {
          await axios
            .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/medicacionActual`, medicamento);
        }),
      );
    },

    async updateMedicacionActual(_, medicacionActual) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            medicacionActual.fk_idHistoriaClinica
          }/medicacionActual/${
            medicacionActual.fk_idMedicacionActual}`,
          medicacionActual,
        );
    },
  },
};
